import { useSelector } from 'react-redux';
import { selectCampaignById } from '@mm/state/selectors/campaignSelectors';

export const useSendCapacityValue = (campaignId?: number) => {
  const campaign = useSelector(state =>
    selectCampaignById(state, campaignId || -1),
  );
  return `${campaign?.sendCapacity || 20} per day`;
};
